import { Component, OnInit } from "@angular/core";
import { ProjectService } from "../project/project.service";
import { AlertStatus, Cooperate } from "../models";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { formatDate } from "@angular/common";
import { AuthService } from "../authentication/auth.service";
import { User } from "../models";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { catchError, map } from "rxjs/operators";
import { forkJoin, of } from "rxjs";

@Component({
  selector: "app-billing",
  templateUrl: "./billing.component.html",
  styleUrls: ["./billing.component.css"],
})
export class BillingComponent implements OnInit {
  activeTab: string = "project";
  searchQuery = "";
  selectedProjects: string[] = [];
  projectSearch = "";
  showFilterPanel = false;
  smsCredits = 100;
  showSmsModal = false;

  corporates: Cooperate[] = [];
  filteredCorporates: Cooperate[] = [];
  selectedCorporate: Cooperate | null = null;
  expandedCorporateId: string | number | null = null;
  projectsOfExpandedCorporate: any[] = [];
  loadingProjects = false;
  showFilterDropdown = false;
  lastUpdated = "";

  kitSmsDetailsMap: { [corporateId: string]: any[] } = {};
  kitsNoRemainingList: string[] = [];
  totalRemaining = 50;
  kitsNoRemaining = 0;
  totalAddons = 14;
  highestSmsKits: { kitId: string; totalSmsSent: number }[] = [];
  highestSmsCount: number = 0;

  smsCreditsForm: FormGroup;
  showSmsPopup = false;
  dropdownOpen = false;
  smsOptions: number[] = [];
  alertUsages = [];

  smsCount: number = 0;
  paymentStatus: string = "unpaid";
  paymentDate: string = "";
  referenceNumber: string = "";
  remarks: string = "";
  isDisabled: boolean = true;
  pricePerSms: number = 0.5;
  totalValuation: number = this.smsCount * this.pricePerSms;
  kitSmsSummaryList: {
    kitId: string;
    totalSmsSent: number;
    lastUpdated: string;
  }[] = [];
  kitsAboveThreshold: { kitId: string; totalSmsSent: number }[] = [];
  kitsAboveThresholdCount: number = 0;
  filteredAlertUsages: any[] = [];
  kitUsersMap: { [kitId: string]: User[] } = {};
  private keepDropdownOpen = false;
  private isSelecting = false;
  overallTotalSmsSent: number = 0;
  overallRemainingSmsSent: number = 0;
  overallPurchasedSmsCount: number = 0;
  overallKitsAboveThreshold: { kitId: string; totalSmsSent: number }[] = [];
  overallKitsAboveThresholdCount: number = 0;
  isProcessingPayment: boolean = false;
  paymentSuccess: boolean = false;

  smsUsages = [
    {
      deviceId: "KIT-001",
      package: "Standard + Add-ons",
      recipients: 5,
      alertUsed: 1500,
      billingCycle: "Monthly",
      nextBilling: "2025-04-25",
    },
    {
      deviceId: "KIT-002",
      package: "Standard",
      recipients: 3,
      alertUsed: 1200,
      billingCycle: "Monthly",
      nextBilling: "2025-04-25",
    },
  ];

  addonHistory = [];

  usageData = [
    {
      corporate: "Alpha Corp",
      project: "Project 01",
      alertSent: 1000,
      entityUsedSMS: 700,
      highestUsage: "$50",
      extraCredit: 700,
    },
    {
      corporate: "Alpha Corp",
      project: "Project 02",
      alertSent: 400,
      entityUsedSMS: 300,
      highestUsage: "$34",
      extraCredit: 500,
    },
    {
      corporate: "Alpha Corp",
      project: "Project 01",
      alertSent: 1000,
      entityUsedSMS: 700,
      highestUsage: "$50",
      extraCredit: 1000,
    },
  ];

  showDropdown = false;
  searchResults: Cooperate[] = [];

  constructor(
    private projectService: ProjectService,
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.loadCorporates();

    this.updateFilteredAlertUsages();

    this.overallKitsAboveThresholdCount = 0;

    this.kitsAboveThresholdCount = 0;

    this.smsCreditsForm = this.fb.group({
      smsCount: [null, [Validators.required, Validators.min(1)]],
    });

    this.smsOptions = Array.from({ length: 1001 }, (_, i) => i);

    this.route.queryParams.subscribe((params) => {
      if (params["tab"]) {
        this.activeTab = params["tab"];
      }
    });
  }

  setTab(tab: string) {
    this.activeTab = tab;
  }

  loadCorporates(): void {
    this.projectService.getCorporates().subscribe(
      (response: any) => {
        this.corporates = response.content || response.data || [];
        this.filteredCorporates = [...this.corporates];
        this.searchQuery = "";

        // Calculate overall totals for all corporates
        this.overallTotalSmsSent = this.corporates.reduce(
          (sum, c) => sum + (c.totalSmsSent || 0),
          0
        );

        this.overallRemainingSmsSent = this.corporates.reduce(
          (sum, c) => sum + (c.totalRemainingCount || 0),
          0
        );

        this.overallPurchasedSmsCount = this.corporates.reduce((sum, c) => {
  const ph = c.purchaseHistory || [];
  const now = new Date();
  const corpRemaining = ph
    .filter(p => this.isActivePurchase(p, now))
    .reduce((acc, p) => acc + this.remainingFromPurchase(p), 0);
  return sum + corpRemaining;
}, 0);


        this.kitsAboveThresholdCount = 0;

        this.calculateOverallKitsAboveThreshold();

        this.loadAllCorporateKitDetails();

        const params = this.route.snapshot.queryParams;
        if (params["corporateId"]) {
          this.selectCorporateById(params["corporateId"]);
        }
      },
      (error) => {
        console.error("Error loading corporates:", error);
      }
    );
  }

  selectCorporateById(corporateId: string): Cooperate | null {
    const corp = this.corporates.find((c) => String(c.id) === corporateId);
    if (corp) {
      this.selectCorporate(corp);
      return corp;
    }
    return null;
  }

  setActiveTab(tab: string): void {
    this.activeTab = tab;
    this.updateUrlParams({ tab });
  }

  applyFilters(name: string): void {
    const lowerName = name.toLowerCase();
    this.filteredCorporates = name
      ? this.corporates.filter((corp) =>
          corp.name.toLowerCase().includes(lowerName)
        )
      : [...this.corporates];
    this.clearExpandedProjectView();
  }

  private updateUrlParams(params: any): void {
    const currentParams = { ...this.route.snapshot.queryParams };

    Object.keys(params).forEach((key) => {
      if (params[key] === null || params[key] === undefined) {
        delete currentParams[key];
      } else {
        currentParams[key] = params[key];
      }
    });

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: currentParams,
      queryParamsHandling: "merge",
    });
  }

  selectCorporate(corp: Cooperate): void {
    if (this.expandedCorporateId === corp.id) {
      this.clearExpandedProjectView();
      this.updateUrlParams({ corporateId: null });
      this.searchQuery = "";
    } else {
      this.expandedCorporateId = corp.id;
      this.selectedCorporate = corp;
      this.selectedProjects = [];
      this.lastUpdated = new Date().toLocaleString();
      this.updateUrlParams({ corporateId: corp.id });
      this.loadProjectsForCorporate(corp.id);
      this.searchQuery = corp.name;

      this.projectService.getKitSmsDetailsByCorporate(corp.id).subscribe(
        (response: { statusCode: string; message: string; content: any[] }) => {
          const kits = response.content || [];
          this.kitSmsDetailsMap[corp.id] = kits;
          this.updateKitsNoRemainingList(corp.id);

          this.kitUsersMap = {};

          kits.forEach((kit) => {
            this.kitUsersMap[kit.kitId] = [];

            this.projectService.getUsersOfKit(kit.kitId).subscribe(
              (userResponse: { content: User[] }) => {
                const users = userResponse.content || [];

                if (!users.length) return;

                const alertChecks$ = users.map((user) =>
                  this.projectService.getUserAlert(kit.kitId, user.id).pipe(
                    map((alertResponse) => {
                      const smsEnabled =
                        alertResponse &&
                        alertResponse.content &&
                        alertResponse.content.modes &&
                        alertResponse.content.modes.SMS === true;
                      return { user, smsEnabled };
                    }),
                    catchError((error) => {
                      console.error(
                        `Alert check failed for user ${user.username}`,
                        error
                      );
                      return of({ user, smsEnabled: false });
                    })
                  )
                );

                forkJoin(alertChecks$).subscribe((results) => {
                  const smsEnabledUsers = results
                    .filter((res) => res.smsEnabled)
                    .map((res) => res.user);

                  this.kitUsersMap[kit.kitId] = smsEnabledUsers;

                  console.log(
                    `Final Recipients (SMS ON) for kit ${kit.kitId}:`,
                    smsEnabledUsers.map((u) => u.username)
                  );
                });
              },
              (error) => {
                console.error(
                  `Failed to load users for kit ${kit.kitId}:`,
                  error
                );
              }
            );
          });

          this.kitSmsSummaryList = kits.map((k) => {
            const d = k.lastUpdated;
            const formattedDate = d
              ? `${d.year}-${String(d.monthOfYear).padStart(2, "0")}-${String(
                  d.dayOfMonth
                ).padStart(2, "0")}`
              : null;

            return {
              kitId: k.kitId,
              totalSmsSent: k.totalSmsSent || 0,
              lastUpdated: formattedDate,
            };
          });

          if (kits.length > 0) {
            const maxSmsSent = Math.max(
              ...kits.map((k) => k.totalSmsSent || 0)
            );

            this.highestSmsKits = kits
              .filter((k) => k.totalSmsSent === maxSmsSent)
              .map((k) => ({ kitId: k.kitId, totalSmsSent: k.totalSmsSent }));
            this.highestSmsCount = this.highestSmsKits.length;

            this.kitsAboveThreshold = kits
              .filter((k) => (k.totalSmsSent || 0) > 10)
              .map((k) => ({ kitId: k.kitId, totalSmsSent: k.totalSmsSent }));
            this.kitsAboveThresholdCount = this.kitsAboveThreshold.length;
          } else {
            this.highestSmsKits = [];
            this.highestSmsCount = 0;
            this.kitsAboveThreshold = [];
          }
        },
        (error) => {
          console.error("Error loading kit SMS details:", error);
          this.kitSmsDetailsMap[corp.id] = [];
          this.kitsNoRemainingList = [];
          this.kitsNoRemaining = 0;

          this.highestSmsKits = [];
          this.highestSmsCount = 0;

          this.kitsAboveThreshold = [];
          this.kitsAboveThresholdCount = 0;

          this.kitSmsSummaryList = [];
        }
      );
    }
  }

  loadProjectsForCorporate(corporateId: string | number): void {
    this.loadingProjects = true;
    this.projectService.getProjectsForUser(corporateId).subscribe(
      (response: any) => {
        this.projectsOfExpandedCorporate = response.content || [];
        const projects = response.content || [];
        this.alertUsages = projects.map((project: any) => ({
          corporate: project.name,
          project: project.name,
          alertSent: project.totalSmsSent || 0,
        }));

        const addonMap = new Map<string, any>();

        projects.forEach((project: any) => {
          if (!addonMap.has(project.name)) {
            const latestPurchase =
              project.purchaseHistory && project.purchaseHistory.length > 0
                ? project.purchaseHistory[project.purchaseHistory.length - 1]
                : null;

            addonMap.set(project.name, {
              corporateName: project.name,
              totalSmsLimit: project.totalSmsLimit || 0,
              totalSmsSent: project.totalSmsSent || 0,
              totalRemainingCount: project.totalRemainingCount || 0,
              latestSmsCount: latestPurchase ? latestPurchase.smsCount : 0,
              latestPurchaseDate: latestPurchase ? latestPurchase.date : null,
              addonCost: latestPurchase ? latestPurchase.valuation : 0,
              billingCycle: latestPurchase ? latestPurchase.remarks : "",
            });
          }
        });

        this.addonHistory = Array.from(addonMap.values());

        this.loadingProjects = false;
      },
      (error) => {
        console.error("Error loading projects:", error);
        this.projectsOfExpandedCorporate = [];
        this.alertUsages = [];
        this.addonHistory = [];
        this.loadingProjects = false;
      }
    );
  }

  updateKitsNoRemainingList(corporateId: string): void {
    const kitDetails = this.kitSmsDetailsMap[corporateId] || [];
    this.kitsNoRemainingList = kitDetails
      .filter((k) => k.remainingCount === 0)
      .map((k) => k.kitId);
    this.kitsNoRemaining = this.kitsNoRemainingList.length;
  }

  getHighestSmsTooltip(): string {
    if (this.highestSmsCount === 0) {
      return "No kits with highest SMS count available.";
    }
    return this.highestSmsKits
      .map((k) => `Kit ${k.kitId}: ${k.totalSmsSent} SMS`)
      .join("\n");
  }

  toggleProjectSelection(project: string): void {
    const index = this.selectedProjects.indexOf(project);
    if (index >= 0) {
      this.selectedProjects.splice(index, 1);
    } else {
      this.selectedProjects.push(project);
    }
    this.updateFilteredAlertUsages();
  }

  clearFilter(): void {
    const currentParams = { ...this.route.snapshot.queryParams };

    if ("corporateId" in currentParams) {
      delete currentParams["corporateId"];
    }

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: currentParams,
      replaceUrl: true,
    });

    this.selectedCorporate = null;
    this.selectedProjects = [];
    this.projectSearch = "";
    this.clearExpandedProjectView();
    this.alertUsages = [];
    this.kitSmsSummaryList = [];
    this.addonHistory = [];
    this.kitsAboveThreshold = [];
    this.kitsAboveThresholdCount = 0;
    this.searchQuery = "";
    this.kitsAboveThreshold = [...this.overallKitsAboveThreshold];
    this.kitsAboveThresholdCount = this.overallKitsAboveThresholdCount;
  }

  filteredProjects(): any[] {
    if (!this.projectSearch) {
      return this.projectsOfExpandedCorporate;
    }
    return this.projectsOfExpandedCorporate.filter((p) =>
      p.name.toLowerCase().includes(this.projectSearch.toLowerCase())
    );
  }

  openSmsAddOnModal(): void {
    this.showSmsModal = true;
  }

  hideDropdown() {
    if (!this.isSelecting) {
      setTimeout(() => {
        this.showDropdown = false;
      }, 200);
    }
  }

  handleCorporateSelection(corp: Cooperate) {
    this.isSelecting = true;

    this.searchQuery = corp.name;

    const fullCorporate = this.corporates.find((c) => c.id === corp.id) || corp;

    this.clearExpandedProjectView();

    this.selectedCorporate = fullCorporate;
    this.expandedCorporateId = fullCorporate.id;

    this.loadProjectsForCorporate(fullCorporate.id);
    this.loadKitSmsDetails(fullCorporate.id);

    setTimeout(() => {
      this.showDropdown = false;
      this.isSelecting = false;
    }, 100);
  }
  loadKitSmsDetails(id: string) {
    throw new Error("Method not implemented.");
  }

  closeSmsAddOnModal(): void {
    this.showSmsModal = false;
  }

  openFilterDropdown(): void {
    this.showFilterDropdown = true;
  }

  closeFilterDropdown(): void {
    this.showFilterDropdown = false;
    this.clearExpandedProjectView();
  }

  private clearExpandedProjectView(): void {
    this.expandedCorporateId = null;
    this.projectsOfExpandedCorporate = [];
    this.selectedCorporate = null;
    this.lastUpdated = "";
    this.highestSmsKits = [];
    this.highestSmsCount = 0;
    this.selectedProjects = [];
  }

  get totalSmsSent(): number {
    return this.selectedCorporate
      ? this.selectedCorporate.totalSmsSent
      : this.overallTotalSmsSent;
  }

  get RemainingtotalSmsSent(): number {
    return this.selectedCorporate
      ? this.selectedCorporate.totalRemainingCount
      : this.overallRemainingSmsSent;
  }

  getTotalPurchasedSmsCount(): number {
  const now = new Date();

  if (this.selectedCorporate) {
    const ph = this.selectedCorporate.purchaseHistory || [];
    return ph
      .filter(p => this.isActivePurchase(p, now))
      .reduce((sum, p) => sum + this.remainingFromPurchase(p), 0);
  }

  // Overall (all corporates)
  return this.corporates.reduce((corpSum, c) => {
    const ph = c.purchaseHistory || [];
    const corpRemaining = ph
      .filter(p => this.isActivePurchase(p, now))
      .reduce((sum, p) => sum + this.remainingFromPurchase(p), 0);
    return corpSum + corpRemaining;
  }, 0);
}


  /** Active (not expired) purchase? */
private isActivePurchase(p: any, now = new Date()): boolean {
const expiredFlag = p && p.expired === true;
const exp = (p && p.expiresAt) ? new Date(p.expiresAt) : null;
  return !expiredFlag && (!exp || exp > now);
}

/** Remaining in a purchase. Prefer remainingCount; fallback to smsCount - usedCount. */
private remainingFromPurchase(p: any): number {
  if (!p) return 0;
  if (typeof p.remainingCount === 'number') return Math.max(0, p.remainingCount);
  const sms = Number(p.smsCount || 0);
  const used = Number(p.usedCount || 0);
  return Math.max(0, sms - used);
}


  get modifiedDate(): string {
    if (this.selectedCorporate && this.selectedCorporate.modifiedDate) {
      return new Date(this.selectedCorporate.modifiedDate).toLocaleString();
    }
    return "Not available";
  }

  toggleSmsPopup() {
    this.showSmsPopup = !this.showSmsPopup;
    if (!this.showSmsPopup) {
      this.resetForm();
    }
  }

  resetForm(): void {
    this.selectedCorporate = null;
    this.smsCount = 0;
    this.pricePerSms = null;
    this.totalValuation = 0;
    this.paymentStatus = "unpaid";
    this.paymentDate = "";
    this.referenceNumber = "";
    this.remarks = "";
    this.paymentSuccess = false;
  }

  toggleDropdown(): void {
    this.dropdownOpen = !this.dropdownOpen;
  }

  onCorporateChange() {
    this.paymentStatus = "unpaid";
    this.paymentDate = "";
    this.referenceNumber = "";
    this.smsCount = null;
    this.pricePerSms = 0.5;
    this.totalValuation = 0;
  }

  addSmsCredits() {
    if (!this.selectedCorporate || !this.selectedCorporate.id) {
      alert("Please select a corporate");
      return;
    }

    if (!this.smsCount || this.smsCount <= 0) {
      alert("Please enter a valid number of SMS credits");
      return;
    }

    const isPaid = this.paymentStatus === "paid";

    const paymentDetails: {
      paymentDate: string;
      referenceNumber: string;
      pricePerSms?: number;
    } = {
      paymentDate: "",
      referenceNumber: "",
      pricePerSms: this.pricePerSms,
    };

    if (isPaid) {
      if (!this.paymentDate || !this.referenceNumber) {
        alert("Please provide payment details");
        return;
      }
      paymentDetails.paymentDate = this.paymentDate;
      paymentDetails.referenceNumber = this.referenceNumber;
    }

    this.isProcessingPayment = true;
    this.paymentSuccess = false;

    this.projectService
      .purchaseSmsCredits(
        this.selectedCorporate.id.toString(),
        this.smsCount,
        isPaid,
        this.remarks,
        paymentDetails
      )
      .subscribe(
        (response) => {
          this.paymentSuccess = true;

          this.loadCorporates();

          setTimeout(() => {
            this.toggleSmsPopup();
            this.resetForm();
            this.isProcessingPayment = false;
          }, 2000);
        },
        (error) => {
          console.error("Error adding SMS credits:", error);
          this.isProcessingPayment = false;
          alert("Failed to add SMS credits. Please try again.");
        }
      );
  }

  todayDate(): string {
    return new Date().toISOString().split("T")[0];
  }

  validateSmsCount(): void {
    if (this.smsCount < 1) {
      this.smsCount = 1;
    } else if (this.smsCount > 10000) {
      this.smsCount = 10000;
    }
    this.calculateTotalValuation();
  }

  calculateTotalValuation(): void {
    this.totalValuation = this.smsCount * this.pricePerSms;
  }

  onPriceChange(): void {
    if (this.pricePerSms < 0) {
      this.pricePerSms = 0;
    }
    this.calculateTotalValuation();
  }

  isFormValid(): boolean {
    if (
      !this.selectedCorporate ||
      !this.smsCount ||
      this.smsCount < 1 ||
      this.pricePerSms <= 0
    ) {
      return false;
    }

    if (this.paymentStatus === "paid") {
      if (!this.paymentDate || !this.referenceNumber) {
        return false;
      }
    }

    return true;
  }

  getLatestPurchaseDate(): string | null {
    if (
      !this.selectedCorporate ||
      !this.selectedCorporate.purchaseHistory ||
      this.selectedCorporate.purchaseHistory.length === 0
    ) {
      return null;
    }

    const latestPurchase =
      this.selectedCorporate.purchaseHistory[
        this.selectedCorporate.purchaseHistory.length - 1
      ];

    return latestPurchase.date || null;
  }

  getLatestPurchaseCost(): number | null {
    if (
      !this.selectedCorporate ||
      !this.selectedCorporate.purchaseHistory ||
      this.selectedCorporate.purchaseHistory.length === 0
    ) {
      return null;
    }

    const latestPurchase =
      this.selectedCorporate.purchaseHistory[
        this.selectedCorporate.purchaseHistory.length - 1
      ];

    return latestPurchase.valuation || null;
  }

  getSmsSentForKit(kitId: string): number {
    const found = this.kitSmsSummaryList.find((k) => k.kitId === kitId);
    return found ? found.totalSmsSent : 0;
  }

  getLatestModifiedDate(): string {
    if (!this.kitSmsSummaryList || this.kitSmsSummaryList.length === 0) {
      return "Not available";
    }

    const sorted = [...this.kitSmsSummaryList].sort(
      (a, b) =>
        new Date(b.lastUpdated).getTime() - new Date(a.lastUpdated).getTime()
    );

    return formatDate(sorted[0].lastUpdated, "yyyy-MM-dd", "en-US");
  }

  isSuperAdmin() {
    return AuthService.isSuperAdmin();
  }

  isCorporateSAASAdmin() {
    return AuthService.isCorporateSAASAdmin();
  }

  isAccountUser() {
    return AuthService.isAccountUser();
  }

  isUserRoleRestricted(): boolean {
    return AuthService.getRole() > 1000;
  }

  downloadPgf(): void {
    const doc = new jsPDF();
    let head: string[][] = [];
    let body: any[][] = [];

    if (this.activeTab === "project") {
      head = [["Corporate", "Project", "Alert Sent"]];
      body = this.alertUsages.map((u) => [
        this.selectedCorporate ? this.selectedCorporate.name : "All Corporate",
        u.project,
        u.alertSent,
      ]);
    } else if (this.activeTab === "kit") {
      head = [
        ["Device ID", "Alert Recipients", "Alert Sent", "Alert Sent Date"],
      ];
      body = this.kitSmsSummaryList.map((k) => [
        k.kitId,
        this.getRecipientNames(k.kitId),
        k.totalSmsSent,
        k.lastUpdated || "N/A",
      ]);
    } else if (this.activeTab === "addon") {
      head = [
        [
          "Corporate",
          "Total SMS",
          "Sent",
          "Remaining",
          "Purchased SMS",
          "Purchased Date",
          "Purchased SMS Cost",
        ],
      ];

      const corporateName = this.selectedCorporate
        ? this.selectedCorporate.name
        : "";
      const totalSmsLimit =
        this.selectedCorporate && this.selectedCorporate.totalSmsLimit
          ? this.selectedCorporate.totalSmsLimit.toString()
          : "";
      const totalSmsSent =
        this.selectedCorporate && this.selectedCorporate.totalSmsSent
          ? this.selectedCorporate.totalSmsSent.toString()
          : "";
      const totalRemaining =
        this.selectedCorporate && this.selectedCorporate.totalRemainingCount
          ? this.selectedCorporate.totalRemainingCount.toString()
          : "";

      body = [];

      for (let purchase of this.selectedCorporate.purchaseHistory) {
        body.push([
          corporateName,
          totalSmsLimit,
          totalSmsSent,
          totalRemaining,
          purchase.smsCount.toString(),
          formatDate(new Date(purchase.date), "yyyy-MM-dd", "en-US"),
          `Rs ${Number(purchase.valuation).toFixed(2)}`,
        ]);
      }
    }

    if (body.length > 0) {
      autoTable(doc, { head, body });
      doc.save(`${this.activeTab}-report.pdf`);
    } else {
      alert("No data available to export.");
    }
  }

  getRecipientNames(kitId: string): string {
    const users = this.kitUsersMap[kitId] || [];
    if (!users.length) return "No recipients";

    const getFullName = (user: User) =>
      [user.name, user.lastName].filter(Boolean).join(" ").trim();

    return (
      users
        .map(getFullName)
        .filter((name) => name)
        .join(", ") || "No named recipients"
    );
  }

  searchCorporates(): void {
    if (!this.searchQuery) {
      this.searchResults = [];
      this.filteredCorporates = [...this.corporates];
      return;
    }

    const query = this.searchQuery.toLowerCase();
    this.searchResults = this.corporates.filter(
      (corporate) =>
        corporate.name.toLowerCase().includes(query) ||
        (corporate.id && corporate.id.toString().includes(query))
    );

    this.filteredCorporates = [...this.searchResults];

    if (
      this.expandedCorporateId &&
      !this.filteredCorporates.some((c) => c.id === this.expandedCorporateId)
    ) {
      this.clearExpandedProjectView();
    }
  }

  selectCorporateFromDropdown(corp: Cooperate): void {
    this.searchQuery = corp.name;
    this.selectCorporate(corp);
    this.showDropdown = false;
    this.keepDropdownOpen = true;
  }

  onSearchBlur() {
    if (!this.keepDropdownOpen) {
      setTimeout(() => {
        this.showDropdown = false;
      }, 200);
    }
    this.keepDropdownOpen = false;
  }

  getLatestSmsCount(): number {
    if (
      !this.selectedCorporate ||
      !this.selectedCorporate.purchaseHistory ||
      this.selectedCorporate.purchaseHistory.length === 0
    ) {
      return 0;
    }

    const latestPurchase =
      this.selectedCorporate.purchaseHistory[
        this.selectedCorporate.purchaseHistory.length - 1
      ];
    return latestPurchase.smsCount || 0;
  }

  updateFilteredAlertUsages(): void {
    let filtered = [...this.alertUsages];

    if (this.projectSearch) {
      const searchTerm = this.projectSearch.toLowerCase();
      filtered = filtered.filter((usage) =>
        usage.project.toLowerCase().includes(searchTerm)
      );
    }

    if (this.selectedProjects.length > 0) {
      filtered = filtered.filter((usage) =>
        this.selectedProjects.includes(usage.project)
      );
    }

    this.filteredAlertUsages = filtered;
  }

  getDisplayedProjects() {
    if (!this.projectSearch && this.selectedProjects.length === 0) {
      return this.alertUsages;
    }
    return this.filteredAlertUsages;
  }

  updateFilteredProjects() {
    let filtered = [...this.alertUsages];

    if (this.projectSearch) {
      const searchTerm = this.projectSearch.toLowerCase();
      filtered = filtered.filter((usage) =>
        usage.project.toLowerCase().includes(searchTerm)
      );
    }

    if (this.selectedProjects.length > 0) {
      filtered = filtered.filter((usage) =>
        this.selectedProjects.includes(usage.project)
      );
    }

    this.filteredAlertUsages = filtered;
  }

  getProjectFilterDisplay(): string {
    if (this.selectedProjects.length === 0) {
      return "All Projects";
    } else if (this.selectedProjects.length === 1) {
      return this.selectedProjects[0];
    } else {
      return `${this.selectedProjects[0]} +${this.selectedProjects.length - 1}`;
    }
  }

  getRecipientNamesTooltip(kitId: string): string {
    const users = this.kitUsersMap[kitId] || [];
    if (!users.length) return "No recipients";

    const maxToShow = 5;
    const getFullName = (user: User) =>
      [user.name, user.lastName].filter(Boolean).join(" ").trim();

    if (users.length <= maxToShow) {
      return users.map(getFullName).join(", ");
    } else {
      const shown = users.slice(0, maxToShow).map(getFullName).join(", ");
      const more = users.length - maxToShow;
      return `${shown}, +${more} more`;
    }
  }

  loadAllCorporateKitDetails(): void {
    const kitDetailRequests = this.corporates.map((corp) =>
      this.projectService.getKitSmsDetailsByCorporate(corp.id).pipe(
        catchError((error) => {
          console.error(
            `Error loading kit details for corporate ${corp.id}:`,
            error
          );
          return of({ content: [] }); 
        })
      )
    );

    forkJoin(kitDetailRequests).subscribe((responses) => {
      this.corporates.forEach((corp, index) => {
        this.kitSmsDetailsMap[corp.id] = responses[index].content || [];
      });

      this.calculateOverallKitsAboveThreshold();

      const params = this.route.snapshot.queryParams;
      if (params["corporateId"]) {
        this.selectCorporateById(params["corporateId"]);
      }
    });
  }

  calculateOverallKitsAboveThreshold(): void {
    if (!this.corporates || this.corporates.length === 0) {
      this.overallKitsAboveThreshold = [];
      this.overallKitsAboveThresholdCount = 0;
      return;
    }

    const allKits = this.corporates.reduce((acc, corp) => {
      const corpKits = this.kitSmsDetailsMap[corp.id] || [];
      return [...acc, ...corpKits];
    }, []);

    this.overallKitsAboveThreshold = allKits
      .filter((kit) => (kit.totalSmsSent || 0) > 10)
      .map((kit) => ({
        kitId: kit.kitId,
        totalSmsSent: kit.totalSmsSent,
      }));

    this.overallKitsAboveThresholdCount = this.overallKitsAboveThreshold.length;

    console.log(
      "Overall kits above threshold:",
      this.overallKitsAboveThreshold
    );
  }

    hasUserRoleAccess() {
    return AuthService.getRole() <= 510;
  }
}
